import React from 'react';
import { Modal, message } from 'antd';
import { useDefaultLandingPageStore } from '@globalStore/defaultLandingPageStore';
import { useDefaultLandingPageMutation } from '@hooks/useDefaultLandingPage';

const RemoveDashboardPopup = ({
  visible,
  toggleVisible,
  isFetching,
  hasError,
  id,
  init,
  removeDashboard,
}) => {
  // Get defaultLandingPage from Zustand and mutation hook
  const defaultLandingPage = useDefaultLandingPageStore((state) => ({
    url: state.url,
    path: state.path,
    name: state.name,
  }));

  // Use the mutation hook for API calls
  const { setDefaultLandingPage: mutateLandingPage } = useDefaultLandingPageMutation();

  React.useEffect(() => {
    if (!visible) {
      init();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);
  const { pathname } = window.location;
  const defaultPathname = defaultLandingPage.url || '';
  const isDefaultLandingPage = defaultPathname.endsWith(pathname);
  const handleOk = React.useCallback(
    () => {
      if (id > 0) {
        if (isDefaultLandingPage) {
          const payload = {
            url: '',
            path: '',
            name: '',
          };
          // Use the mutation hook which handles both API call and local state update
          mutateLandingPage(payload);
          removeDashboard(id, isDefaultLandingPage);
        } else {
          removeDashboard(id, isDefaultLandingPage);
        }
      } else {
        message.error("Can't find the dashboard.");
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [id, defaultLandingPage, mutateLandingPage],
  );

  const strArr = ['Are you sure you want to delete the dashboard?'];
  if (isDefaultLandingPage) {
    strArr.push(
      'Note: This dashboard is set as your default landing page. If deleted, your default landing page will reset to Conviva default.',
    );
  }
  const contentArr = strArr.map((e) => <div key={e}>{e}</div>);

  return (
    <Modal
      title="Delete dashboard"
      open={visible}
      onOk={handleOk}
      confirmLoading={!hasError && isFetching}
      onCancel={toggleVisible}
      maskClosable={false}
    >
      {contentArr}
    </Modal>
  );
};

export default RemoveDashboardPopup;
